import moment from "moment";

export const getCurrencyFromType = (typeValue) => {
    if (!typeValue) {
        return "0";
    }
    return String(typeValue).split("-")[0];
};

export const getIsoCurrency = (currencyCode) => (currencyCode === "2" ? "USD" : "ARS");

export const normalizeOptionValue = (value) => {
    if (value && typeof value === "object" && "value" in value) {
        return value.value;
    }
    return value;
};

export const normalizeNumber = (value) => {
    if (value === null || value === undefined || value === "") {
        return null;
    }
    const parsed =
        typeof value === "number"
            ? value
            : Number(
                  String(value)
                      .replace(/\./g, "")
                      .replace(",", "."),
              );
    return Number.isNaN(parsed) ? null : parsed;
};

export const calculateDueDate = (environmentDate, termInDays) => {
    if (!termInDays || !environmentDate) {
        return null;
    }
    return moment(String(environmentDate).replace("Z", ""))
        .add(termInDays, "days")
        .toDate();
};

export const calculateTermInDays = (environmentDate, dueDate) => {
    if (!dueDate || !environmentDate) {
        return 0;
    }
    const envDate = moment(environmentDate).startOf("day");
    const dueDateMoment = moment(dueDate).startOf("day");
    return dueDateMoment.diff(envDate, "days");
};

export const syncTermToDate = (formikProps, environmentDate, term) => {
    if (!formikProps) {
        return;
    }
    const newDueDate = calculateDueDate(environmentDate, term);
    formikProps.setFieldValue("dueDate", newDueDate);
};

export const syncDateToTerm = (formikProps, environmentDate, date, defaultDaysQuantity) => {
    if (!formikProps) {
        return;
    }
    const termInDays = date ? calculateTermInDays(environmentDate, date) : defaultDaysQuantity;
    formikProps.setFieldValue("term", termInDays);
};

export const validateAndResetTerm = (formikProps, environmentDate, value, defaultDaysQuantity) => {
    if (!formikProps) {
        return;
    }

    const currentTerm = value !== undefined && value !== null && value !== "" ? Number(value) : 0;

    if (currentTerm === 0 || currentTerm < defaultDaysQuantity) {
        formikProps.setFieldValue("term", defaultDaysQuantity, false);
        const newDueDate = calculateDueDate(environmentDate, defaultDaysQuantity);
        formikProps.setFieldValue("dueDate", newDueDate, false);

        formikProps.setFieldError("term", undefined);

        setTimeout(() => {
            formikProps.validateField("term").then((error) => {
                if (error) {
                    formikProps.setFieldError("term", undefined);
                }
            });
        }, 0);
    }
};
